// extracted by mini-css-extract-plugin
export var badge = "Notification-module--badge--94a5f";
export var container = "Notification-module--container--e256f";
export var danger = "Notification-module--danger--57948";
export var icon = "Notification-module--icon--97162";
export var iconSkeleton = "Notification-module--iconSkeleton--12691";
export var info = "Notification-module--info--007ad";
export var isRead = "Notification-module--isRead--905e8";
export var success = "Notification-module--success--4d71b";
export var text = "Notification-module--text--df2c0";
export var time = "Notification-module--time--92d8c";
export var warning = "Notification-module--warning--dab63";